
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gG0ijG6wWM8vqS51hG4eI64BRGEoKYpRwqIJ05kmlJgEMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexwBRpsZb6uwn6Z5q0Oj3fmID_qM_45cCalCNKtDKYDEBoAMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchAYDAk_459in2WbppuafMvYLhMCmc2Lkx_XYvPDH0VaGOYMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexUm6leZqBg3hqy5lecueOeaT7RXi6E0lqHOd0DQr6q2QMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ztuODBToiBahahyuNLoVKOLNQ7YEEcmekd7dzlLW_45sgMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index45G5MnloP_upvcbKsy54XCxyCl0484TpXa_45u0bMEg9wMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93l_45J_PrKBTJecCJYfGIkNVvOVsnAKaKYKESVkirh4ae4Meta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexWjXCjCBXBm4ZkKqQoUgk0NOJRQlYasGMqPMWKEblZOsMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93i7gmR9zfbWs63f9_45puNQOkjKYVQfCanOljHzh5lvwecMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index6U9hleAGiO0KUvXd04_JhaO1UvlFcZcQL5kB8jY6ZQcMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexFl4kjMzgoqmEXWsXcXGcL48M_45ou71hbpvKhEGnwMLVMMeta } from "/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index45G5MnloP_upvcbKsy54XCxyCl0484TpXa_45u0bMEg9wMeta || {},
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexWjXCjCBXBm4ZkKqQoUgk0NOJRQlYasGMqPMWKEblZOsMeta || {},
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index6U9hleAGiO0KUvXd04_JhaO1UvlFcZcQL5kB8jY6ZQcMeta || {},
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexFl4kjMzgoqmEXWsXcXGcL48M_45ou71hbpvKhEGnwMLVMMeta || {},
    component: () => import("/codebuild/output/src4116399354/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]